// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6452":"88fd9782","6850":"77983c06"}[chunkId] + ".chunk.css";
};